var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoIco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3096 39.6965L18.3096 0.495628L22.0078 0.495628L22.0078 39.6965L18.3096 39.6965Z",
    fill: "#D7922A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 32.6437L32.7114 4.92451L35.3264 7.53953L7.60721 35.2588L4.99219 32.6437Z",
    fill: "#D7922A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.558594 18.2471H39.7595V21.9453H0.558594V18.2471Z",
    fill: "#D7922A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60645 4.92462L35.3257 32.6438L32.7107 35.2589L4.99142 7.53964L7.60645 4.92462Z",
    fill: "#D7922A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40527 26.0918L37.4595 10.7034L38.9113 14.1048L2.85701 29.4931L1.40527 26.0918Z",
    fill: "#D7922A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 11.0742L39.0395 25.6872L37.6609 29.1188L1.28548 14.5059L2.66406 11.0742Z",
    fill: "#D7922A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.165 1.34503L29.5534 37.3993L26.1521 38.851L10.7637 2.79676L14.165 1.34503Z",
    fill: "#D7922A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1846 2.59821L14.5716 38.9736L11.1399 37.595L25.7529 1.21962L29.1846 2.59821Z",
    fill: "#D7922A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoIco1);
export default __webpack_public_path__ + "static/media/decoIco1.403195b301f5cc11ecd2e9c59901dca5.svg";
export { ForwardRef as ReactComponent };